import AccessRestrictedPage from '../../components/AccessRestrictedPage';

const DepartamentoPage = () => {
  return (
    <AccessRestrictedPage
      title="Departamentos"
      message="O perfil CLIENT não possui endpoint compatível para consultar o cadastro administrativo de departamentos. O acesso foi bloqueado para evitar leitura indevida de recursos restritos."
    />
  );
};

export default DepartamentoPage;
